module.exports = {
    STATUS_200: 200,
    STATUS_400: 400,
    CURRENCIES: ["EUR", "USD", "GBP", "CAD", "TWD", "AUD", "NZD"]
};
